import classNames from 'classnames';
import { useHideGetItBy } from '../hooks';

type OwnProps = {
  getItBy: string;
};

export default function GetItBy({ getItBy }: OwnProps) {
  const hideGetItBy = useHideGetItBy(getItBy);

  return (
    <div
      data-qa="get-it-by"
      className={classNames('font-normal mr-4 text-xs', {
        invisible: hideGetItBy
      })}
    >
      Get it {getItBy === 'Today' ? getItBy : `by ${getItBy}`}
    </div>
  );
}
